import { DefaultTheme, Theme } from "@react-navigation/native";

export default {
  ...DefaultTheme,
  colors: {
    background: "#ffffff",
  },
} as Theme;
